import React, { useEffect, useState } from 'react'
import { Dropdown, DropdownItem, DropdownMenu } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { DropdownProps } from 'semantic-ui-react';
import { handleErrors } from '~/utils/helpers';
import { DownloadService } from '~/api/services/downloadFiles';
import { MilkMoneyQuery } from '~/QueryHooks/MilkMoneyQuery';

const StyledMenu = styled(Dropdown)<DropdownProps>`
  background: ${({ theme }) => theme?.firstColor} !important;
  color: white !important;

  .item {
    font-size: 15px !important;
    i {
      font-size: 15px !important;
    }
  }
  
  .menu {
    max-height: 300px !important;
    overflow-y: auto !important;
  }
`;

const MSWSetup:React.FC = () => {
  const { t } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)

  const {
    data: templateData,
    isLoading: isLoadingTemplateData,
    refetch: fetchTemplateData
  } = MilkMoneyQuery.getTourTemplateData()

  useEffect(() => {
    fetchTemplateData()
  }, [t])

  async function handleDownloadFile(url, data?, name?) {
    setIsLoading(true)
    try {
      await DownloadService.downloadFileWithName(url, { ...data }, name ?? '')
    } catch(error) {
      handleErrors(error)
    }
    setIsLoading(false)
  }

  return <StyledMenu
    text={'MSW-Aufstellung'}
    icon='cloud download'
    floating
    direction={'left'}
    labeled
    button
    className='icon'
    loading={isLoading || isLoadingTemplateData}
  >
    <DropdownMenu>
      {templateData?.truckNumbers?.map((truckNumber) => {
        return <DropdownItem
          key={truckNumber?.key}
          onClick={() => handleDownloadFile('milk-money/tour-planning/template/export', { truckNumber: truckNumber?.key })}
          text={truckNumber.label}
        />
      })}
    </DropdownMenu>
  </StyledMenu>
}
export default MSWSetup